import React, { forwardRef, ReactNode, RefForwardingComponent, useImperativeHandle, useState } from 'react';

import { useMountStatus } from '../../hooks/useMountStatus';

import Confirm, { Props as ConfirmProps } from './Confirm';

export interface Handles {
    open: (props: {
        title?: string;
        description: ReactNode;
        onConfirm: () => Promise<void> | void;
        width?: number;
        confirmText?: string;
        rejectText?: string;
    }) => void;
}

const noop = async () => {
    /* do nothing */
};

const UnmanagedConfirmRefForwarding: RefForwardingComponent<Handles> = (_, ref) => {
    const [state, setState] = useState<ConfirmProps>({
        visible: false,
        progress: false,
        title: '',
        description: '',
        onConfirm: noop,
        onReject: noop,
        width: undefined,
        confirmText: undefined,
        rejectText: undefined,
    });

    const mountStatusRef = useMountStatus();

    useImperativeHandle<Handles, Handles>(ref, () => ({
        open({ onConfirm, ...rest }) {
            setState({
                visible: true,
                progress: false,
                onReject: () => {
                    setState((prev) => ({ ...prev, visible: false }));
                },
                onConfirm: async () => {
                    setState((prev) => ({ ...prev, progress: true }));
                    await onConfirm();
                    if (!mountStatusRef.current) {
                        return;
                    }

                    setState((prev) => ({ ...prev, visible: false }));
                },
                ...rest,
            });
        },
    }));

    return <Confirm {...state} />;
};

export const UnmanagedConfirm = forwardRef(UnmanagedConfirmRefForwarding);
